<template>
  <card-modal :visible="visible" @close="close" :height="height" transition="zoom" ref="modal">
    <div class="customer-edit-box" slot="body" :style="style">
      <h4 class="page-title">{{$t('page_title')}} [{{props_data.index + 1}}{{$t('person')}}]</h4>
      <h4 class="page-title-s">{{$t('page_title_s')}} [{{props_data.index + 1}}{{$t('person')}}]</h4>
      <div class="popup-contents-box">

        <div class="sub-contents-box">
          <div class="customer-info">
            <div class="flex">
              <p class="info-title"><span class="red">※</span>{{$t('name')}}</p>
              <p class="info-item"><input type="text" name="name" v-model="customer_info.name" /></p>
            </div>

            <div class="flex">
              <p class="info-title"><!-- <span class="red">※</span> -->{{$t('sex')}}</p>
              <p class="info-item">
                <input id="sex1" type="radio" name="sex" v-model="customer_info.sex" value="1" />
                <label for="sex1">{{$t('sex1')}}</label>
                <input id="sex2" type="radio" name="sex" v-model="customer_info.sex" value="2" />
                <label for="sex2">{{$t('sex2')}}</label>
              </p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red">※</span>{{$t('age')}}</p>
              <p class="info-item"><input type="number" class="s-width" min="0" max="200" name="age" v-model.number="customer_info.age"></p>
            </div>

            <!-- <div class="flex">
              <p class="info-title">{{$t('post_no')}}<span class="red">※</span></p>
              <p class="info-item"><input type="text" placeholder='ex: 00000-0000' name="post code" v-model="customer_info.post"></p>
            </div> -->

            <div class="flex">
              <p class="info-title"><span class="red" v-if="props_data.index == 0">※</span>{{$t('email')}}</p>
              <p class="info-item"><input type="text" name="email" v-model="customer_info.email"></p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red">※</span>{{$t('address')}}</p>
              <p class="info-item">
                <input type="text" name="address" v-model="customer_info.address">
                <span>{{$t('address_about')}}</span>
              </p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red" v-if="props_data.index == 0">※</span>{{$t('tel')}}</p>
              <p class="info-item"><input type="text" placeholder="ex: 000-0000-0000" v-model="customer_info.tel"></p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red">※</span>{{$t('job')}}</p>
              <p class="info-item"><input type="text" v-model="customer_info.occuoation"></p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red">※</span>{{$t('p_dext')}}</p>
              <p class="info-item">
                <input type="text" v-model="customer_info.prior_destination">
                <span>{{$t('pn_about')}}</span>
              </p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red">※</span>{{$t('n_dext')}}</p>
              <p class="info-item">
                <input type="text" v-model="customer_info.next_destination">
                <span>{{$t('pn_about')}}</span>
              </p>
            </div>

            <div class="flex">
              <p class="info-title"><span v-if="(datepicker_lang != 'ja')" class="red">※</span>{{$t('nationality')}}</p>
              <p class="info-item"><input type="text" v-model="customer_info.nationality"></p>
            </div>

            <div class="flex">
              <p class="info-title"><span v-if="(datepicker_lang != 'ja')" class="red">※</span>{{$t('passport_no')}}</p>
              <p class="info-item"><input type="text" v-model="customer_info.passport_no"></p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red" v-if="props_data.index == 0">※</span>{{$t('check_in')}}</p>
              <p class="info-item flex3">
                <vuejs-datepicker :format="format" :language="languages[datepicker_lang]" v-model="customer_info.check_in" disabled>
                </vuejs-datepicker>
                <select class="" name="" v-model="check_in.h">
                  <option v-for="(value, index) in (24 - check_in_s)" :key="index" :value="(index + check_in_s)">{{index + check_in_s}}</option>
                </select>
                <span>：</span>
                <select class="" name="" v-model="check_in.m">
                  <option v-for="(value, index) in minute" :key="index" :value="value">{{value}}</option>
                </select>
              </p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red" v-if="props_data.index == 0">※</span>{{$t('check_out')}}</p>
              <p class="info-item flex3">
                <vuejs-datepicker :format="format" :language="languages[datepicker_lang]" v-model="customer_info.check_out" disabled>
                </vuejs-datepicker>
                <select class="" name="" v-model="check_out.h">
                  <option v-for="(value, index) in check_out_e" :key="index" :value="(check_out_e - index)">{{check_out_e - index}}</option>
                </select>
                <span>：</span>
                <select class="" name="" v-model="check_out.m">
                  <option v-for="(value, index) in minute" :key="index" :value="value">{{value}}</option>
                </select>
              </p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('room_name')}}</p>
              <p class="info-item"><input class="" disabled type="text" v-model="customer_info.room_name" /></p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red" v-if="(datepicker_lang == 'ja') && props_data.index == 0">※</span>{{$t('other')}}</p>
              <p class="info-item"><textarea class="" v-model="customer_info.other"></textarea></p>
            </div>

            <div class="flex">
              <p class="info-title"><span v-if="(datepicker_lang != 'ja')" class="red">※</span>{{$t('passport_copy')}}</p>
              <p class="info-item">
                <img :src="dataUrl1" v-if="dataUrl1">

                <label class="file-label" for="fileup">{{$t('fileup')}}
                  <input type="file" accept="image/*" @change="file_select($event, 'dataUrl1')" text="aa" id="fileup">
                </label>
                <span class="fileup_attention">{{$t('fileup_attention')}}</span>
              </p>
            </div>

            <div class="flex" v-if="(datepicker_lang == 'ja' || (datepicker_lang == 'en' && passport_limit == 3))">
              <!-- <p class="info-title"><span v-if="(datepicker_lang == 'ja' || (datepicker_lang == 'en' && passport_limit == 3))" class="red">※</span>{{$t('face_photo')}}</p> -->
              <p class="info-title"><span v-if="(datepicker_lang == 'en' && passport_limit == 3)" class="red">※</span>{{$t('face_photo')}}</p>
              <p class="info-item">
                <img :src="dataUrl2" v-if="dataUrl2">

                <label class="file-label" for="fileup2">{{$t('fileup')}}
                  <input type="file" accept="image/*" @change="file_select($event, 'dataUrl2')" text="aa" id="fileup2">
                </label>
              </p>
            </div>

          </div>
          <p><span class="red2">※</span>{{$t('required_fields')}}</p>
          <p><span class="red2">※</span>{{$t('required_fields2')}}</p>
        </div>

      </div>
      <div class="flex2">
        <input type="button" class="new-add" @click="cancel" :value="$t('back')" />
        <input type="button" class="new-add" @click="send" :value="$t('registration')" />
      </div>

    </div>
  </card-modal>
</template>

<script>
import BaseModal from '@/lib/BasePopup';
import vuejsDatepicker from 'vuejs-datepicker';
import * as lang from "vuejs-datepicker/src/locale";
export default {
  mixins: [BaseModal],
  name: 'CustomerEdit',
  // ===========================================================================
  // language
  // ===========================================================================
  language: {
    'ja': {
      'page_title': '宿泊者情報詳細',
      'page_title_s': '宿泊者情報詳細',
      'name': '氏名（漢字）',
      'sex': '性別',
      'age': '年齢',
      'post_no': '郵便番号',
      'email': 'email',
      'address': 'ご住所',
      'address_about': '',
      'tel': '電話番号',
      'job': 'ご職業',
      'p_dext': '前泊地',
      'n_dext': '行先地',
      'pn_about': '（分からない場合は、国や住所の地名を記入してください。）',
      'nationality': '国籍',
      'passport_no': 'パスポート番号',
      'check_in': 'ご到着',
      'check_out': 'ご出発',
      'room_name': '客室名',
      'other': 'その他(合計宿泊人数)\n例：男⚪︎名、女⚪︎名',
      'person': '人目',
      'back': '戻る',
      'registration': '登録',
      'sex1': '男',
      'sex2': '女',
      'passport_copy': 'パスポートのコピー',
      'fileup': 'ファイルを選択',
      'required_fields': 'は必ず入力してください。',
      'required_fields2': '日本国籍以外の方は、パスポート番号記載の上、パスポートのコピーをアップロードしてください。',
      'enter_err': '未入力の項目：',
      'enter_ok': '宿泊者情報を登録しました。',
      'fileup_attention': '',
      'face_photo': '顔写真',
      'alert1': 'パスポートの顔写真が判別できません。',
      'alert2': '顔写真を登録してください。',
      'alert3': 'もう一度、パスポートのコピーを設定してください。',
      'alert4': '顔写真が判別できません。',
      'alert5': 'もう一度、顔写真を登録してください。'
    },
    'en': {
      'page_title': 'Guest information details',
      'page_title_s': 'Guest information',
      'name': 'Guest name\n客人姓名\n손님 이름',
      'sex': 'Sex\n性别\n섹스',
      'age': 'Age\n年龄\n나이',
      'post_no': 'Postal code',
      'email': 'email',
      'address': 'Address\n地址\n주소',
      'address_about': 'Be sure to include your official home address, not just the country or region.\n確保包括您的正式家庭住址，而不僅僅是國家或地區。\n请提供您的官方家庭住址，而不仅仅是国家或地区。\n국가 나 지역 이름뿐 아니라 정식 집 주소를 기입하십시오.',
      'tel': 'Phone number\n电话号码\n전화 번호',
      'job': 'Occupation\n占用\n직업',
      'p_dext': 'Prior Destination\n预先目的地\n이전 목적지',
      'n_dext': 'Next Destination\n下一个目的地\n다음 목적지',
      'pn_about': '（If you do not understand, please fill in the place name of the country or address.）',
      'nationality': 'Nationality\n国籍\n국적',
      'passport_no': 'Passport No.',
      'check_in': 'Check-in.\n报到\n체크인',
      'check_out': 'Check-out.\n查看\n점검',
      'room_name': 'Room No.\n房间号\n객실 번호',
      'other': 'Other',
      'person': ' person',
      'back': 'back',
      'registration': 'Register',
      'sex1': 'Male',
      'sex2': 'Female',
      'passport_copy': 'copy of passport\n护照复印件\n여권 사본',
      'fileup': 'Select file',
      'required_fields': ' is required fields.',
      'required_fields2': ' If you are not a Japanese national, you should upload your copy of your passport by posting your passport number.',
      'enter_err': 'Please enter ',
      'enter_ok': 'Registered guest information.',
      'fileup_attention': '※Please note the following for passport uploads.\n　・Please upload your front photo. Please do not turn sideways.\n　・Please photograph the whole picture containing the face picture.\n　・Depending on the brightness of the light or darkess, the photo may not be clear.\n　・Please do not copy your finger in the picture.\n\n※上传护照请注意以下事项。\n　·请上传你的正面照片。 请不要侧身。·请拍摄包含脸部图片的整张照片。\n　·根据灯光或暗点的亮度，照片可能不清晰。·请不要将手指复制到图片中。\n\n※ 여권 업로드는 다음과 같습니다.\n　· 앞 사진을 업로드하십시오. 옆으로 돌리지 마십시오.\n　· 얼굴 사진을 포함한 전체 사진을 촬영하십시오.\n　· 밝거나 어두움의 밝기에 따라 사진이 선명하지 않을 수 있습니다.\n　· 사진에서 손가락을 복사하지 마십시오.',
      'face_photo': 'Face Photo',
      'alert1': 'I can’t identify my passport photo.',
      'alert2': 'Please register your face photo.',
      'alert3': 'Set up a copy of your passport again.',
      'alert4': 'The face photo cannot be identified.',
      'alert5': 'Please register your face photo again.'
    }
  },
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    vuejsDatepicker,
  },
  // ===========================================================================
  // props
  // ===========================================================================
  props: {
    props_data: null,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      width: 'calc(100vw - 60px)',
      // height: 'calc(100% - 135px)',
      height: '100%',
      // height: `calc(${this.props_data.height}px - 80px)`,
      format: 'yyyy/MM/dd',
      datepicker_lang: this.$store.getters['loginInfo/lang'],
      languages: lang,

      customer_info: {},
      minute: ['00', '10', '15', '20', '30', '40', '45', '50'],
      check_in: {},
      check_out: {},
      dataUrl1: null,
      dataUrl2: null,
      edit_flg: false,
      check_in_s: 0,
      check_out_e: 23,
      passport_limit: 0,
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    if (this.props_data.list.id) {

      let ld = new this.$loader(this);
      ld._data_set({customer_id: this.props_data.list.id});
      ld._post_cb_f = this.data_get_cb;
      ld._load_start('user_customer_info_get.php');
    } else {
      this.customer_info.check_in = this.props_data.lodg_data.check_in;
      this.customer_info.check_out = this.props_data.lodg_data.check_out;
      this.customer_info.room_name = this.props_data.lodg_data.listing_name;
    }

    this.check_in_s = this.$lib._pint(this.props_data.owner.check_in.split(':')[0]);
    this.check_out_e = this.$lib._pint(this.props_data.owner.check_out.split(':')[0]);
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    data_get_cb (res) {
      this.customer_info = res.data.customer_info;
      let work = null;
      let work2 = null;
      if (res.data.customer_info.check_in) {
        work = res.data.customer_info.check_in.split('-');
        work2 = work[1].split(':');
        this.check_in.h = work2[0];
        this.check_in.m = work2[1];
      } else {
        this.customer_info.check_in = this.props_data.lodg_data.check_in;
      }
      if (res.data.customer_info.check_out) {
        work = res.data.customer_info.check_out.split('-');
        work2 = work[1].split(':');
        this.check_out.h = work2[0];
        this.check_out.m = work2[1];
      } else {
        this.customer_info.check_out = this.props_data.lodg_data.check_out;
      }

      this.dataUrl1 = res.data.customer_info.passport;
      this.dataUrl2 = res.data.customer_info.facephoto;
      if (this.customer_info.facephoto !== '') {
        // 顔写真あり
        this.passport_limit = 3;
      }
    },
    cancel () {
      if (this.edit_flg === true) {
        this.props_data.cb();
      }
      this.close();
    },
    file_select (evt, type) {
      if (evt.target.files.length === 0) {
        return;
      }
      const file = evt.target.files;
      const reader = new FileReader();
      this.customer_info[type] = file[0];
      reader.readAsDataURL(file[0]);
      reader.onload = () => { return this.load(reader, type); };
    },
    load (reader, type) {
      this[type] = reader.result;
    },
    send () {
      if (this.$lib._emptyChk(this.customer_info.name) === false) {
        this.$alert('alert', (this.$t('enter_err') + this.$t('name')));
        return;
      }
      // if (this.$lib._emptyChk(this.customer_info.sex) === false) {
      //   this.$alert('alert', (this.$t('enter_err') + this.$t('sex')));
      //   return;
      // }
      if (this.$lib._emptyChk(this.customer_info.age) === false) {
        this.$alert('alert', (this.$t('enter_err') + this.$t('age')));
        return;
      }
      // if (this.$lib._emptyChk(this.customer_info.post) === false) {
      //   this.$alert('alert', (this.$t('enter_err') + this.$t('post_no')));
      //   return;
      // }
      if (this.$lib._emptyChk(this.customer_info.address) === false) {
        this.$alert('alert', (this.$t('enter_err') + this.$t('address')));
        return;
      }
      if (this.props_data.index === 0 && this.$lib._emptyChk(this.customer_info.email) === false) {
        this.$alert('alert', (this.$t('enter_err') + this.$t('email')));
        return;
      }
      if (this.props_data.index === 0 && this.$lib._emptyChk(this.customer_info.tel) === false) {
        this.$alert('alert', (this.$t('enter_err') + this.$t('tel')));
        return;
      }
      if (this.$lib._emptyChk(this.customer_info.occuoation) === false) {
        this.$alert('alert', (this.$t('enter_err') + this.$t('job')));
        return;
      }
      if (this.$lib._emptyChk(this.customer_info.prior_destination) === false) {
        this.$alert('alert', (this.$t('enter_err') + this.$t('p_dext')));
        return;
      }
      if (this.$lib._emptyChk(this.customer_info.next_destination) === false) {
        this.$alert('alert', (this.$t('enter_err') + this.$t('n_dext')));
        return;
      }
      if (
        this.$lib._emptyChk(this.customer_info.check_in) === false ||
        this.$lib._emptyChk(this.check_in.h) === false ||
        this.$lib._emptyChk(this.check_in.m) === false
      ) {
        if (this.props_data.index === 0) {
          this.$alert('alert', (this.$t('enter_err') + this.$t('check_in')));
          return;
        } else {
          this.customer_info.check_in = '';
        }
      } else {
        let check_in = this.$children[0].$children[0].$children[0].formattedValue;
        check_in = `${check_in}-${this.check_in.h}:${this.check_in.m}`;
        this.customer_info.check_in = check_in;
      }
      if (
        this.$lib._emptyChk(this.customer_info.check_out) === false ||
        this.$lib._emptyChk(this.check_out.h) === false ||
        this.$lib._emptyChk(this.check_out.m) === false
      ) {
        if (this.props_data.index === 0) {
          this.$alert('alert', (this.$t('enter_err') + this.$t('check_out')));
          return;
        } else {
          this.customer_info.check_out = '';
        }
      } else {
        let check_out = this.$children[0].$children[1].$children[0].formattedValue;
        check_out = `${check_out}-${this.check_out.h}:${this.check_out.m}`;
        this.customer_info.check_out = check_out;
      }
      // if (this.$lib._emptyChk(this.customer_info.room_name) === false) {
      //   this.$alert('alert', (this.$t('enter_err') + this.$t('room_name')));
      //   return;
      // }
      if (this.$store.getters['loginInfo/lang'] !== 'ja') {
        // 日本以外
        if (this.$lib._emptyChk(this.customer_info.nationality) === false) {
          this.$alert('alert', (this.$t('enter_err') + this.$t('nationality')));
          return;
        }
        if (this.$lib._emptyChk(this.customer_info.passport_no) === false) {
          this.$alert('alert', (this.$t('enter_err') + this.$t('passport_no')));
          return;
        }
        if (!this.customer_info.id && this.$lib._emptyChk(this.customer_info.dataUrl1) === false) {
          this.$alert('alert', (this.$t('enter_err') + this.$t('passport_copy')));
          return;
        }
      }
      // if (this.$store.getters['loginInfo/lang'] === 'ja' || (this.$store.getters['loginInfo/lang'] === 'en' && this.passport_limit === 3)) {
      if (this.$store.getters['loginInfo/lang'] === 'en' && this.passport_limit === 3) {
        if (!this.customer_info.id && this.$lib._emptyChk(this.customer_info.dataUrl2) === false) {
          this.$alert('alert', (this.$t('enter_err') + this.$t('face_photo')));
          return;
        }
      }
      // orderを設定
      this.customer_info.order = this.props_data.index + 1;

      let ld = new this.$loader(this);
      if (this.customer_info.id) {
        ld._upload_data_set({data: this.customer_info}, this.customer_info.dataUrl1, this.customer_info.dataUrl2, 'customer_edit.php');
      } else {
        ld._upload_data_set({data: this.customer_info}, this.customer_info.dataUrl1, this.customer_info.dataUrl2, 'customer_add.php');
      }
      ld._post_cb_f = this.upload_cb;
      ld._upload_start();
    },
    upload_cb (res) {
      if (res.res === 1) {
        if (res.data.face_check === true) {
          this.$alert('info', this.$t('enter_ok'));
          this.edit_flg = true;
          this.cancel();
        } else {
          if (this.passport_limit < 3 && this.$store.getters['loginInfo/lang'] !== 'ja') {
            this.passport_limit++;
            if (this.passport_limit === 3) {
              this.$alert('alert', `${this.$t('alert1')}\n${this.$t('alert2')}`);
            } else {
              this.$alert('alert', `${this.$t('alert1')}\n${this.$t('alert3')}`);
            }
          } else {
            this.$alert('alert', `${this.$t('alert4')}\n${this.$t('alert5')}`);
          }
        }
      }
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.customer-edit-box {
  background-color: #fefefe;
  padding: 20px;
  .popup-contents-box {
    margin: 20px 0;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    // height: calc(100vh - 255px);
    height: calc(100% - 120px);
    .guide-p {
      height: 40px;
      overflow: auto;
    }
  }
  .sub-contents-box {
    margin-bottom: 0px;
    margin-right: 0px;
  }
  h4 {
    font-size: 18px;
    border-bottom: solid 1px #d3d4d8;
    width: 100%;
    padding: 0px 0px 5px 0px;
    color: #24273b;
  }
  .page-title-s {
    display: none;
  }
  .new-add {
    display: block;
    text-align: center;
    padding: 8px 8px 8px 8px;
    font-size: 16px;
    text-decoration: none;
    border-radius: 3px;
    width: 150px;
  }

  .customer-info {
    border-bottom: 1px solid #d3d4d8;
  }

  .info-title {
    min-width: 180px;
    padding: 6px 13px 3px 3px;
    background: #fbfbfb;
    text-align: right;
    line-height: 1.5;
    border-top: 1px solid #d3d4d8;
    border-left: 1px solid #d3d4d8;
    color: #24273b;
    white-space: pre-wrap;
  }

  .info-item {
    padding: 5px;
    flex: 1;
    border-top: 1px solid #d3d4d8;
    border-left: 1px solid #d3d4d8;
    border-right: 1px solid #d3d4d8;
    span {
      white-space: pre-wrap;
    }
  }
  .flex2 {
    display: flex;
    justify-content:space-between;
  }
  .flex3 {
    display: flex;
  }
  .vdp-datepicker {
    width: 100px;
    margin-right: 10px;
  }
  .s-width {
    width: 80px;
  }
  img {
    width: 100%;
  }
  label > input {
    display:none;	/* アップロードボタンのスタイルを無効にする */
  }
  .file-label {
    color: #ff6e5a;
    display: block;
    text-align: center;
    padding: 1px;
    font-size: 16px;
    text-decoration: none;
    border-radius: 3px;
    width: 150px;
    font-weight: 800;
    background-color: #f6f6f7;
    border: 1px solid #ff6e5a;
    transition: all 0.2s ease;
  }
  .file-label:hover {
    color: #24273b;
    border: 1px solid #24273b;
  }
  .red {
    color: #ff6e5a;
    float: right;
  }
  .red2 {
    color: #ff6e5a;
  }
  .fileup_attention {
    white-space: pre-wrap;
    font-size: 12px;
  }
  @media (max-width: 767px) {
    .customer-info {
      border: initial;
    }
    .flex {
      display: block;
      border: initial;
    }
    .info-title {
      width: auto;
      padding: 3px;
      border: initial;
      text-align: left;
    }

    .info-item {
      padding: 5px;
      border: initial;
    }

    .page-title {
      display: none;
    }

    .page-title-s {
      display: inline-block;
    }

    .new-add {
      width: 120px;
    }
  }
}
</style>
